// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#performance-viewer {
  display: grid;
  height: 100%;
  width: 100%;
  grid-template-columns: 300px 1fr;
  font-family: "acumin-pro";
}
#performance-viewer .performancePlayheadButton {
  grid-area: liveButton;
  height: 30px;
  width: 100px;
  justify-self: right;
  background-color: #dcdfe1;
  color: #2e3f47;
  outline: 2px #2e3f47;
  margin: 5px;
  position: absolute;
  top: 10px;
  right: 10px;
}
#performance-viewer #performance-viewer-sidebar {
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  border: 2px solid gray;
}
#performance-viewer #performance-viewer-sidebar .sidebar-item {
  display: grid;
  width: 100%;
  height: 30px;
  font-size: 14px;
  padding: 2.5px 0px;
  align-items: center;
}
#performance-viewer #performance-viewer-sidebar .header {
  color: white;
  grid-template-columns: 10px 9fr 1fr 10px;
}
#performance-viewer #performance-viewer-sidebar .header .category {
  grid-column: 2;
}
#performance-viewer #performance-viewer-sidebar .header .value {
  grid-column: 3;
}
#performance-viewer #performance-viewer-sidebar .version-header {
  background-color: #2e3f47;
  color: white;
  grid-template-columns: 10px 1fr 1fr 10px;
  font-size: 14px;
  height: 35px;
}
#performance-viewer #performance-viewer-sidebar .version-header .category {
  grid-column: 2;
}
#performance-viewer #performance-viewer-sidebar .version-header .value {
  grid-column: 3;
  display: flex;
  justify-content: end;
}
#performance-viewer #performance-viewer-sidebar .category-header {
  background-color: #4a5960;
  text-transform: uppercase;
  font-size: 14px;
  height: 30px;
}
#performance-viewer #performance-viewer-sidebar .category-header .checkBoxLine {
  color: #dcdfe1;
}
#performance-viewer #performance-viewer-sidebar .measure {
  color: black;
  grid-template-columns: 18px 6fr 1fr;
  font-family: "acumin-pro-condensed";
}
#performance-viewer #performance-viewer-sidebar .measure .category {
  display: grid;
  grid-template-columns: 18px 7px 18px 10px 1fr;
  grid-column: 2;
  align-items: center;
}
#performance-viewer #performance-viewer-sidebar .measure .category .color-picker {
  grid-column: 3;
}
#performance-viewer #performance-viewer-sidebar .measure .category .sidebar-item-label {
  grid-column: 5;
}
#performance-viewer #performance-viewer-sidebar .measure .value {
  grid-column: 3;
}
#performance-viewer #performance-viewer-sidebar .measure:nth-child(odd) {
  background-color: #dcdfe1;
}
#performance-viewer #performance-viewer-sidebar .measure:nth-child(even) {
  background-color: #ebedee;
}
#performance-viewer #performance-viewer-sidebar .checkBoxLine {
  color: #4a5960;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
#performance-viewer #performance-viewer-sidebar .checkBoxLine .disabled {
  color: lightgray;
}
#performance-viewer #performance-viewer-sidebar .color-picker {
  width: 100%;
}
#performance-viewer #performance-viewer-sidebar .color-picker .color-rect {
  height: 18px;
  width: 18px;
  cursor: pointer;
}
#performance-viewer #performance-viewer-sidebar .color-picker .color-picker-cover {
  position: fixed;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  z-index: 100;
}
#performance-viewer #performance-viewer-sidebar .color-picker .color-picker-float {
  position: absolute;
}
#performance-viewer #performance-viewer-sidebar .color-picker .color-picker-float .color-picker-container {
  width: 200px;
}`, "",{"version":3,"sources":["webpack://./../../../dev/inspector/dist/components/actionTabs/tabs/performanceViewer/scss/performanceViewer.scss"],"names":[],"mappings":"AAGA;EACI,aAAA;EACA,YAAA;EACA,WAAA;EACA,gCAAA;EACA,yBAAA;AAFJ;AAII;EACI,qBAAA;EACA,YAZO;EAaP,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,cAAA;EACA,oBAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;AAFR;AAKI;EACI,aAAA;EACA,sBAAA;EACA,kBAAA;EAEA,sBAAA;AAJR;AAMQ;EACI,aAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;AAJZ;AAOQ;EACI,YAAA;EACA,wCAAA;AALZ;AAOY;EACI,cAAA;AALhB;AAQY;EACI,cAAA;AANhB;AAUQ;EACI,yBAAA;EACA,YAAA;EACA,wCAAA;EACA,eAAA;EACA,YAAA;AARZ;AAUY;EACI,cAAA;AARhB;AAWY;EACI,cAAA;EACA,aAAA;EACA,oBAAA;AAThB;AAcQ;EACI,yBAAA;EACA,yBAAA;EACA,eAAA;EACA,YAAA;AAZZ;AAcY;EACI,cAAA;AAZhB;AAgBQ;EACI,YAAA;EACA,mCAAA;EACA,mCAAA;AAdZ;AAgBY;EACI,aAAA;EACA,6CAAA;EACA,cAAA;EACA,mBAAA;AAdhB;AAgBgB;EACI,cAAA;AAdpB;AAiBgB;EACI,cAAA;AAfpB;AAmBY;EACI,cAAA;AAjBhB;AAsBQ;EACI,yBAAA;AApBZ;AAwBQ;EACI,yBAAA;AAtBZ;AAyBQ;EACI,cAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAvBZ;AAwBY;EACI,gBAAA;AAtBhB;AA0BQ;EACI,WAAA;AAxBZ;AA0BY;EACI,YArIH;EAsIG,WAtIH;EAuIG,eAAA;AAxBhB;AA2BY;EACI,eAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,SAAA;EACA,YAAA;AAzBhB;AA4BY;EACI,kBAAA;AA1BhB;AA4BgB;EACI,YAAA;AA1BpB","sourcesContent":["$buttonHeight: 30px;\r\n$squareSize: 18px;\r\n\r\n#performance-viewer {\r\n    display: grid;\r\n    height: 100%;\r\n    width: 100%;\r\n    grid-template-columns: 300px 1fr;\r\n    font-family: \"acumin-pro\";\r\n\r\n    .performancePlayheadButton {\r\n        grid-area: liveButton;\r\n        height: $buttonHeight;\r\n        width: 100px;\r\n        justify-self: right;\r\n        background-color: #dcdfe1;\r\n        color: #2e3f47;\r\n        outline: 2px #2e3f47;\r\n        margin: 5px;\r\n        position: absolute;\r\n        top: 10px;\r\n        right: 10px;\r\n    }\r\n\r\n    #performance-viewer-sidebar {\r\n        display: flex;\r\n        flex-direction: column;\r\n        overflow-y: scroll;\r\n\r\n        border: 2px solid gray;\r\n\r\n        .sidebar-item {\r\n            display: grid;\r\n            width: 100%;\r\n            height: 30px;\r\n            font-size: 14px;\r\n            padding: 2.5px 0px;\r\n            align-items: center;\r\n        }\r\n\r\n        .header {\r\n            color: white;\r\n            grid-template-columns: 10px 9fr 1fr 10px;\r\n\r\n            .category {\r\n                grid-column: 2;\r\n            }\r\n\r\n            .value {\r\n                grid-column: 3;\r\n            }\r\n        }\r\n\r\n        .version-header {\r\n            background-color: #2e3f47;\r\n            color: white;\r\n            grid-template-columns: 10px 1fr 1fr 10px;\r\n            font-size: 14px;\r\n            height: 35px; // with padding, we get 40px\r\n\r\n            .category {\r\n                grid-column: 2;\r\n            }\r\n\r\n            .value {\r\n                grid-column: 3;\r\n                display: flex;\r\n                justify-content: end;\r\n            }\r\n        }\r\n\r\n        // mid-dark color\r\n        .category-header {\r\n            background-color: #4a5960;\r\n            text-transform: uppercase;\r\n            font-size: 14px;\r\n            height: 30px;\r\n\r\n            .checkBoxLine {\r\n                color: #dcdfe1;\r\n            }\r\n        }\r\n\r\n        .measure {\r\n            color: black;\r\n            grid-template-columns: $squareSize 6fr 1fr;\r\n            font-family: \"acumin-pro-condensed\";\r\n\r\n            .category {\r\n                display: grid;\r\n                grid-template-columns: $squareSize 7px $squareSize 10px 1fr;\r\n                grid-column: 2;\r\n                align-items: center;\r\n\r\n                .color-picker {\r\n                    grid-column: 3;\r\n                }\r\n\r\n                .sidebar-item-label {\r\n                    grid-column: 5;\r\n                }\r\n            }\r\n\r\n            .value {\r\n                grid-column: 3;\r\n            }\r\n        }\r\n\r\n        //darker color\r\n        .measure:nth-child(odd) {\r\n            background-color: #dcdfe1;\r\n        }\r\n\r\n        // lighter color\r\n        .measure:nth-child(even) {\r\n            background-color: #ebedee;\r\n        }\r\n\r\n        .checkBoxLine {\r\n            color: #4a5960;\r\n            width: 100%;\r\n            height: 100%;\r\n            display: flex;\r\n            justify-content: center;\r\n            align-items: center;\r\n            .disabled {\r\n                color: lightgray;\r\n            }\r\n        }\r\n\r\n        .color-picker {\r\n            width: 100%;\r\n\r\n            .color-rect {\r\n                height: $squareSize;\r\n                width: $squareSize;\r\n                cursor: pointer;\r\n            }\r\n\r\n            .color-picker-cover {\r\n                position: fixed;\r\n                top: 0px;\r\n                right: 0px;\r\n                bottom: 0px;\r\n                left: 0px;\r\n                z-index: 100;\r\n            }\r\n\r\n            .color-picker-float {\r\n                position: absolute;\r\n\r\n                .color-picker-container {\r\n                    width: 200px;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
